export default "<template>\n    <slot name=\"tab-heading\"></slot>\n</template>";